import browser from './browser';
import jSendStatus from '@/script/common/models/jsend';
import { jQueryPostJson } from './jquery-networking';
import axios from '@/script/common/axios-common';

function hideServerMessages ($context?: JQuery) {
	if ($context) {
		$('.server-rule-violation-summary, .server-failure-summary', $context).hide();
	} else {
		$('.server-rule-violation-summary, .server-failure-summary').hide();
	}
}

function handlePostJsonFailure (resp: JQuery.jqXHR,
	handleErrors: (messages: any) => any = displayServerRuleViolations,
	handleUnauthenticatedFailure: () => any = redirectToLoginPage,
	handleUnknownFailure: () => any = displayServerFailure) {
	if (resp && resp.responseJSON && resp.responseJSON.status) {
		// response is JSend / IDispatcherResult
		if (resp.responseJSON.status === jSendStatus.ERROR) {
			handleUnknownFailure();
		} else if (resp.responseJSON.status === jSendStatus.FAIL) {
			handleErrors(resp.responseJSON.data);
		}
	} else if (resp.status === 401) {
		handleUnauthenticatedFailure();
	} else {
		// response is ICommandResult, this is an unhandled exception
		// TODO: remove when fully migrated
		handleUnknownFailure();
	}
}

function postFormCommand ($form: JQuery,
	buildCommand: () => any,
	handleErrors: (response: any) => any,
	handleUnauthenticatedFailure: () => any,
	handleUnknownFailure: () => any,
	$context?: JQuery,
	onProcessingComplete?: ($form: JQuery) => any) {
	if (!$form.length || typeof buildCommand !== 'function') {
		return;
	}
	handleErrors = handleErrors || $.noop;
	handleUnknownFailure = handleUnknownFailure || $.noop;

	const isPending = $form.data('is-pending');
	if (isPending) {
		return;
	}

	// TODO: should anti-forgery tokens be added?
	const validationActive = $.validator;
	if (validationActive) {
		const validate = $form.validate();
		if (validate && !$form.valid()) {
			return;
		}
	}

	hideServerMessages($context);
	$form.data('is-pending', true);

	const url: string = $form.attr('action')!;

	jQueryPostJson(url, buildCommand())
		.then((resp: any) => {
			if (resp.status) {
				// response is JSend / IDispatcherResult
				browser.redirect(resp.redirectUrl);
			} else {
				// response is ICommandResult
				// check for error messages
				// TODO: remove when fully migrated
				if (!resp.wasSuccessful) {
					const ruleViolations = resp.ruleViolations;
					handleErrors(ruleViolations);

					if (validationActive) {
						displayErrors($form, ruleViolations);
					}
				} else {
					window.location = resp.commandRedirectUrl;
				}
			}
		})
		.fail((resp: any) => {
			handlePostJsonFailure(resp, handleErrors, handleUnauthenticatedFailure, handleUnknownFailure);
			if (validationActive) {
				displayErrors($form, resp.responseJSON.data);
			}
		})
		.always(() => {
			$form.data('is-pending', false);
			if (onProcessingComplete) {
				onProcessingComplete($form);
			}
		});
}

function displayErrors ($form: JQuery, ruleViolations: any[]) {
	if (!ruleViolations) {
		return;
	}

	const validator = $form.validate();
	const errors: any = {};

	ruleViolations.forEach((v: any) => {
		const msg = v.message;

		v.fields.forEach((f: any) => {
			const field: string = f || '';
			if (field !== '') {
				errors[field] = msg;
			}
		});
	});

	validator.showErrors(errors);
}

function makeFormPostCommand (formSelector: string, buildCommand: () => any,
	handleErrors: (messages: any) => any = displayServerRuleViolations,
	handleUnauthenticatedFailure: () => any = redirectToLoginPage,
	handleUnknownFailure: () => any = displayServerFailure,
	onProcessingComplete?: ($form: JQuery) => any) {
	const $form = $(formSelector);
	if (!$form.length || typeof buildCommand !== 'function') {
		return;
	}

	$form.on('submit',
		(e) => {
			e.preventDefault();
			postFormCommand($form, buildCommand, handleErrors,
				handleUnauthenticatedFailure, handleUnknownFailure, undefined, onProcessingComplete);
		});
}

function displayError ($errorElement: JQuery) {
	$errorElement
		.addClass('validation-summary-errors')
		.removeClass('validation-summary-valid')
		.show();
}

function makeDisplayServerRuleViolations (targetCssSelector: string) {
	return (messages: string[], $context?: JQuery) => {
		const errors = messages.reduce((prev: string, current: any) => `${prev}<li>${current.message}</li>`, '');

		if ($context) {
			$(targetCssSelector + ' ul', $context).html(errors);
			displayError($(targetCssSelector, $context));
		} else {
			$(targetCssSelector + ' ul').html(errors);
			displayError($(targetCssSelector));
		}
	};
}

function makeDisplayServerFailure (targetCssSelector: string) {
	return ($context?: JQuery) => {
		if ($context) {
			displayError($(targetCssSelector, $context));
			return;
		}
		displayError($(targetCssSelector));
	};
}

function displayServerRuleViolations (messages: any, $context?: JQuery) {
	return makeDisplayServerRuleViolations('.server-rule-violation-summary')(messages, $context);
}

function displayServerFailure ($context?: JQuery) {
	return makeDisplayServerFailure('.server-failure-summary')($context);
}

function redirectToLoginPage () {
	browser.redirect('/identity/account/login');
}

function handleJSendFailedResponse (jSendResponse: any) {
	if (jSendResponse.responseJSON.status === jSendStatus.ERROR) {
		displayServerFailure();
	} else if (jSendResponse.responseJSON.status === jSendStatus.FAIL) {
		displayServerRuleViolations(jSendResponse.responseJSON.data);
	}
}

function getInputValue (selector: string): string | null {
	const element = document.querySelector(selector) as HTMLInputElement;

	if (!element) {
		return null;
	}

	const val = (element as HTMLInputElement).value;
	return (val === '') ? null : val;
}

function getInputCheckedValue (selector: string): boolean {
	const element = document.querySelector(selector) as HTMLInputElement;
	return element.checked || false;
}

function getSelectedRadioValue (selector: string): string | null {
	const checkedSelector = `${selector}:checked`;
	const element = document.querySelector(checkedSelector) as HTMLInputElement;

	return (element == null) ? null : element.value;
}

function convertToBoolean (val: string): boolean {
	return (val || '').toLowerCase() === 'true';
}

function getDropdownSelectedItem (selector: string): HTMLSelectElement | null {
	return document.querySelector(selector) as HTMLSelectElement;
}

function getDropdownSelectedValue (selector: string): string | null {
	const item = getDropdownSelectedItem(selector);
	return item ? item.value : null;
}

function getAllDropdownSelectedValues (selector: string): string[] {
	const options = document.querySelectorAll(selector) as NodeListOf<HTMLSelectElement>;

	const result: string[] = [];
	let opt: HTMLSelectElement;

	for (let i = 0, iLen = options.length; i < iLen; i++) {
		opt = options[i];

		if (opt.value) {
			result.push(opt.value);
		}
	}
	return result;
}

function textToHyperlinks (selector: string) {
	$(selector).each((index: number, element: HTMLElement) => {
		const $element = $(element);
		const regex = /(https?:\/\/([-\w\.]+)+(:\d+)?(\/([\w\/_\.]*(\?\S+)?)?)?)/ig;
		const hyperlinkText = $element.html().replace(regex, '<a href="$1" target="_blank">$1</a>');
		$element.html(hyperlinkText);
	});
}

function formatFormHelpText () {
	textToHyperlinks('.help-text');
}

// find first error input or first field in form (for unhandled errors) and set focus to it
// used to allow users to see errors on large forms
function focusOnFirstError ($form: JQuery<HTMLElement>) {
	let $firstElement = $form.find('.is-invalid').first();
	if ($firstElement.length === 0) {
		$firstElement = $form.find(':input:visible:enabled').first();
	}

	if ($firstElement.length > 0) {
		$firstElement.focus();
	} else {
		window.scrollTo(0, 0);
	}
}

export default {
	hideServerMessages,
	postFormCommand,
	makeFormPostCommand,
	displayError,
	makeDisplayServerRuleViolations,
	makeDisplayServerFailure,
	displayServerRuleViolations,
	displayServerFailure,
	handleJSendFailedResponse,
	handlePostJsonFailure,
	getInputValue,
	getDropdownSelectedValue,
	getAllDropdownSelectedValues,
	redirectToLoginPage,
	getInputCheckedValue,
	formatFormHelpText,
	focusOnFirstError,
	getSelectedRadioValue,
	convertToBoolean
};
